<template>
  <div>
    <!-- 日期选择 -->
    <div v-if="titleObj.showDate">
      <div v-if="dateArr.length < 2" class="text-59">
        {{ $t(dateArr[0].tip, [titleObj.attributeName]).d(dateArr[0].tipText) }}
      </div>
      <yxtf-dropdown
        v-else
        trigger="click"
        @command="handleDateChange"
        class="yxtbiz-rank__rank-title-dropdown cursor-point"
      >
        {{ $t(activeDate.label).d(activeDate.text) }}
        <yxtf-dropdown-menu slot="dropdown">
          <yxtf-dropdown-item
            v-for="(item, index) of dateArr"
            :key="index"
            :command="item"
            :class="{
              'color-primary-6-i': item.type === titleObj.defaultDateType
            }"
            >{{ $t(item.label).d(item.text) }}</yxtf-dropdown-item
          >
        </yxtf-dropdown-menu>
      </yxtf-dropdown>
    </div>
  </div>
</template>
<script>
import { dateList } from '../config';

export default {
  inject: ['titleFun'],
  computed: {
    // 榜单名称数据
    titleObj() {
      return this.titleFun();
    },
    // 日期选择数组
    dateArr() {
      const arr = [];
      this.titleObj.dateArr.forEach(d => {
        arr.push(dateList[d - 1]);
      });
      arr.sort((a, b) => a.type - b.type);
      return arr;
    },
    // 当前选择的日期
    activeDate() {
      return this.dateArr.find(d => d.type === this.titleObj.defaultDateType) || {};
    }
  },
  methods: {
    // 日期类型更改时
    handleDateChange(item) {
      this.$emit('changeDate', item.type);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
